import { getClasses, getComponent, getID } from './../../common/utils';

Row.version = 1000;
Object.defineProperty(Row, 'name', {
  writable: true,
  value: 'Row'
});


export function Row(props:any) {

    let componentClasses = getClasses(props.data);
    let componentID = getID(props.data);
    let childCells:any = "";
    if( props.data.components ) {
        childCells = getComponent(props.data.components);
    }
    
    return (
        <div id={componentID} className={componentClasses}>
            {childCells}
        </div>
    )
    
}
